import TilePlaceholder from './TilePlaceholder'

export default TilePlaceholder
// eslint-disable-next-line import/export
export * from './TilePlaceholder'
